import { getFeature } from 'Cloud/Application/FeaturesEs6';

// CLOUDWEB-19450
// Показываем баннер + модалку с фейкдором промо ai-фич

/** id промо - для включения нужно будет включать фичу 3promo-enable-{id} */
export const PROMO_ID = 'ai-generate-and-edit-fakedoor';
/** Ключ для локалстораджа от тултипа */
export const storageKeyForTooltips = `${PROMO_ID}-tooltips-data`;
/** Ключ для локалстораджа от баннера */
export const storageKeyForBanner = `3promo:${PROMO_ID}`;

/** Временной промежуток между показами одной и той же промки, в секундах */
export const showInterval: number = +getFeature(`${PROMO_ID}-show-interval`) || 86400;
/** Максимальное количество закрытий промки (на крестик в баннере / на primary кнопку) */
export const closeLimit: number = +getFeature(`${PROMO_ID}-close-limit`) || 1;
/** Максимальное количество показов, в которых не взаимодействуют с промкой */
export const showLimit: number = +getFeature(`${PROMO_ID}-show-limit`) || 3;
/** Минимальное количество медиа-файлов для показа промки */
export const minCountMediaFiles: number = +getFeature(`${PROMO_ID}-min-count-media-files`) || 0;
/** Файлы, которые мы считаем медиа */
export const mediaFileTypes: string[] = getFeature('media-file-types') || ['png', 'jpg', 'jpeg', 'heic', 'mp4'];
/** Показывать ли иконки с тултипами в списке файлов/просмотрщике */
export const isShowAiTooltipOnMediaFilesFeature: boolean = !!getFeature(`${PROMO_ID}-show-tooltips`);
/** Сколько раз показываем иконки с тултипами */
export const maxCountShowAiTooltipOnMediaFiles: number = +getFeature(`${PROMO_ID}-tooltips-max-count-show`) || 3;
/** Временной промежуток между показами тултипов */
export const showIntervalTooltip: number = +getFeature(`${PROMO_ID}-tooltips-show-interval`) || 86400;
/** Включает анимацию в баннере */
export const isAnimatedBanner: boolean = !!getFeature(`${PROMO_ID}-animated-banner`);
